import {converseDisabled, environment, apiHost, apiProtocol} from 'settings'
import {subdomainResource} from 'utils/url'
import create from 'utils/command'

const server = subdomainResource(apiHost)
const loglevel = environment == 'production' ? 'info' : 'debug'

const hooks =  [
    {paths: ['refreshSettings/'], resolves:[refreshSettings]}
]

export {hooks as default}

export async function refreshSettings({update}) {
  if (converseDisabled) return
  const data = await create('openfire', 'settings')()
  update({settings: {$set: handleSettings(data)}})
}

function handleSettings(data) {
  const [settings] = data
  const {serviceName, domainName, boshPort, boshSSLPort, id, groups, nick} = settings
  const port = apiProtocol == 'http' ? boshPort : boshSSLPort
  const jid = `${id}@${domainName}`
  const bosh_service_url = `//${domainName}:${port}/http-bind`
  const auto_join_rooms = groups.map(group => ({jid: `${group.roomName}@${serviceName}.${domainName}`, nick, naturalName: group.naturalName}))
  const prebind_url = `//${server}/security/prebind`
  return {
    hidden_occupants: true,
    allow_logout: false,
    allow_refresh_profile: true,
    allow_contact_removal: false,
    allow_non_roster_messaging: true,
    roster_groups: false,
    allow_bookmarks: false,
    allow_contact_requests: false,
    allow_muc_invitations: false,
    sounds_path: subdomainResource('static','sounds',''),
    message_archiving: true,
    show_client_info: false,
    show_profile_modal: false,
    muc_show_room_features: false,
    fullname: nick,
    prebind_url,
    prebind_with_credentials: true,
    bosh_service_url,
    auto_join_rooms_nickname: nick,
    auto_join_rooms,
    auto_subscribe: true,
    jid,
    loglevel,
    authentication: 'prebind',
    trusted: false,
    auto_login: true,
    auto_reconnect: true,
  }
}
